<template>
  <div>
    <v-card class="main-card" v-if="!$AuthSvc.isLogin() || !$AuthSvc.isAdmin()">
      <v-card-title style="padding-bottom:0">
        <span class="page-title">Course Admin</span>
      </v-card-title>
      Must login as ADMIN to view data
    </v-card>

    <v-card class="main-card" v-if="$AuthSvc.isLogin() && $AuthSvc.isAdmin()">
      <v-card-title style="padding-bottom:0">
        <span class="page-title">Course Admin</span>
      </v-card-title>

      <v-card-text>

        <div class="leftPane">
          <span class="label18">Course Lists:</span>
          <v-simple-table class="select-table">
            <tr v-for="course in courses" :key="course.courseId">
              <td class="courseItem"
                  @click="selectCourse=course;selectCourseId=course.courseId"
                  :class="{courseItemSelect: selectCourseId===course.courseId}">
                {{course.name}}
              </td>
            </tr>
          </v-simple-table>
        </div>

        <div class="rightPane">
          <div class="button-div">
            <a class="selectBtn" @click="initNewCourse()" v-if="selectCourse===null">New</a>
            <a class="selectBtn" @click="saveCourse()" v-if="selectCourse!==null">Save</a>
            <a class="selectBtn" @click="deleteCourse()" v-if="selectCourse!==null">Delete</a>
            <a class="selectBtn" @click="cancel()" v-if="selectCourse!==null">Cancel</a>
          </div>

          <v-card-text v-if="selectCourse!== null">
            <span class="label18">Course Information:</span>
            <div v-if="selectCourse !== null">
              <div class="dataEnter">
                <span>Course ID:</span> {{selectCourse.courseId}}
              </div>
              <div class="dataEnter">
                <span class="clabel">Course Name:</span>
                <input class="okagaBtn" v-model="selectCourse.name"/>
              </div>
              <div class="dataEnter">
                <span class="clabel">Description:</span>
                <input class="okagaBtn" v-model="selectCourse.description"/>
              </div>
              <div class="dataEnter">
                <span class="clabel">Image Name:</span>
                <input class="okagaBtn" v-model="selectCourse.image"/>
              </div>
              <div class="dataEnter">
                <span class="clabel">Location:</span>
                <input class="okagaBtn" v-model="selectCourse.location"/>
              </div>
              <div class="dataEnter">
                <span class="clabel">Website:</span>
                <input class="okagaBtn" v-model="selectCourse.website"/>
              </div>
              <div class="dataEnter">
                <span class="clabel">Slope:</span>
                <input class="okagaBtn" v-model="selectCourse.slope"/>
              </div>
              <div class="dataEnter">
                <span class="clabel">Rating:</span>
                <input class="okagaBtn" v-model="selectCourse.rating"/>
              </div>
              <div class="dataEnter">
                <span class="clabel">HCP List:</span>
                <input class="okagaBtn" v-model="selectCourse.hcp" @change="checkHCP()"/>
              </div>
              <div class="dataEnter">
                <span class="clabel">Par List:</span>
                <input class="okagaBtn" v-model="selectCourse.par" @change="checkParList()"/>
              </div>
              <div class="dataEnter">
                <span class="clabel">Tee List:</span>
                <input class="okagaBtn" v-model="selectCourse.tee" @change="checkTeeList()"/>
              </div>
              <div class="dataEnter">
                <span class="clabel">Yardage List:</span>
                <input class="okagaBtn" v-model="selectCourse.yardage" @change="checkYardageList()"/>
              </div>
            </div>

            <div class="sample-entry">
              <span class="label16">SAMPLE ENTRY:</span><br>
              <v-card-text style="margin-left: 12px">
                <span class="label14">Course Name:</span> Cedar Crest<br>
                <span class="label14">Description:</span> Cedar Crest Golf Course at 1800 Southerland Ave, Dallas, TX 75203<br>
                <span class="label14">Image Name:</span> cedar-crest.jpeg<br>
                <span class="label14">Location:</span> 1800 Southerland Ave, Dallas, TX 75203,<br>
                <span class="label14">Website:</span> https://www.golfcedarcrest.com<br>
                <span class="label14">Slope:</span> 134<br>
                <span class="label14">Rating:</span> 73.8<br>
                <span class="label14">HCP List:</span> [2,17,3,6,13,10,9,16,12,1,4,15,18,8,7,11,5,14]<br>
                <span class="label14">Par List:</span> [5,4,3,4,4,3,5,4,3,35,4,3,4,4,5,3,5,3,4,35,70]<br>
                <span class="label14">Tee List:</span> [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18]<br>
                <span class="label14">Yardage List:</span> [611,362,206,467,402,185,552,315,180,3280,482,226,358,408,551,211,561,221,428,3446,6726]<br>
                <br>
              </v-card-text>
            </div>
          </v-card-text>
        </div>

      </v-card-text>
    </v-card>

  </div>

</template>

<script>
  import moment from 'moment';
  import swal from 'sweetalert';

    export default {
      name: "scheduleEdit",
      data: () => ({
        selectCourse: null,
        selectCourseId: 0,
        courses: []
      }),
      mounted: function() {
        this.$AuthSvc.authenticated(this.loadCourses);
      },
      methods: {
        checkHCP() {
          try {
            var text1 = this.selectCourse.hcp.replace(" ", ",");
            var text2 = text1.replace("\t", ",");
            var text = "[" + text2 + "]";
            var test = JSON.parse(text2);
            if (test.length === 18) {
              return true;
            }
          } catch (e) {
          }
          swal("ERROR", "Bad HCP List format. See example and try again.", "error");
          return false;
        },
        checkParList() {
          try {
            var test = JSON.parse(this.selectCourse.par);
            if (test.length === 21) {
              return true;
            }
          } catch (e) {
          }
          swal("ERROR", "Bad PAR List format. See example and try again.", "error");
          return false;
        },
        checkTeeList() {
          try {
            var test = JSON.parse(this.selectCourse.tee);
            if (test.length === 18) {
              return true;
            }
          } catch (e) {
          }
          swal("ERROR", "Bad TEE List format. See example and try again.", "error");
          return false;
        },
        checkYardageList() {
          try {
            var test = JSON.parse(this.selectCourse.yardage);
            if (test.length === 21) {
              return true;
            }
          } catch (e) {
          }
          swal("ERROR", "Bad Yardage List format. See example and try again.", "error");
          return false;
        },
        loadCourses() {
            var _this = this;
            _this.axios.get('/public/courses')
            .then(function (response) {
                _this.courses = response.data;
            })
            .catch(function (error) {
                console.log('ERROR: ' + error);
            });
        },
        initNewCourse() {
          this.selectCourse = {
                "courseId": 0,
                "description": "",
                "hcp": "",
                "image": "pebble-beach.png",
                "location": "",
                "name": "",
                "par": "",
                "rating": 0,
                "slope": 0,
                "tee": "",
                "website": "",
                "yardage": ""
          };
        },
        cancel() {
          window.location.href = '/course-admin';
        },
        saveCourse() {
          var _this = this;

          if (!this.checkHCP() || !this.checkParList() || !this.checkTeeList() || !this.checkYardageList()) {
            return;
          }

          if (this.selectCourse.name === '') {
            swal("ERROR", "Course Name required.", "error");
            return;
          } else if (this.selectCourse.description === '') {
            swal("ERROR", "Description required.", "error");
            return;
          } else if (this.selectCourse.image === '') {
            swal("ERROR", "Image name required.", "error");
            return;
          } else if (this.selectCourse.website === '') {
            swal("ERROR", "Website required.", "error");
            return;
          } else if (this.selectCourse.slope < 10) {
            swal("ERROR", "Slope required.", "error");
            return;
          } else if (this.selectCourse.rating < 10) {
            swal("ERROR", "Rating required.", "error");
            return;
          }

          _this.axios.post('/admin/courses', _this.selectCourse)
          .then(function (response) {
              console.log('SAVE Course Successful ' + response.data);
              _this.selectCourse = null;
              _this.loadCourses();
          })
          .catch(function (error) {
              console.log('ERROR: ' + error);
          });
        },
        deleteCourse() {
          var _this = this;

          swal({
            title: "Are you sure?",
            text: "Once deleted " + _this.selectCourse.name +", you cannot recover!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
          })
            .then((willDelete) => {
              if (willDelete) {
                _this.axios.delete('/admin/courses/' + _this.selectCourse.courseId)
                .then(function (response) {
                    console.log('DELETE Course Successful ' + response.data);
                    _this.selectCourse = null;
                    _this.loadCourses();
                })
                .catch(function (error) {
                    console.log('ERROR: ' + error);
                });
              }
            });
        }

      }
    }

</script>

<style scoped>

  .dataEnter {
    width: 100%;
    padding: 5px;
  }

  .clabel {
    width: 100%;
    font-size: 14px;
    font-weight: bold;
  }

  .dataEnter > span {
    display: inline-block;
  }

  .dataEnter > input {
    display: inline-block;
    width: 100%;
    background-color: white;
  }
  .courseItem {
    padding: 3px;
  }

  .courseItemSelect {
    background-color: lightgray;
  }

  .button-div {
    width: 100%;
    margin-bottom: 12px;
  }

  .selectBtn {
    font-size: 14px;
    font-weight: bold;
    padding: 3px;
    margin-right: 7px;
  }

  .leftPane, .rightPane {
    display: inline-block;
    padding: 10px;
    border: 1px solid black;
    overflow-y: scroll;
  }

  .leftPane {
    width: 100%;
    height: 200px;
  }

  .rightPane {
    width: 100%;
    height: 370px;
  }

  .sample-entry {
    margin-top: 12px;
  }

  @media (min-width: 768px) {
    .main-card {
        min-height: 600px;
    }

    .clabel {
      width: 15%;
    }

    .dataEnter > input {
      display: inline-block;
      margin-left: 10px;
      width: 83%;
    }

    .leftPane, .rightPane {
      height: 540px;
      float: left;
    }

    .leftPane {
      width: 25%;
      margin-right: 7px;
    }

    .rightPane {
      width: 70%;
    }
  }
</style>